import React from 'react';
import { Link } from 'react-router-dom';
import './Projects.css';
import case1 from '../../assets/case-2.png';
import case2 from '../../assets/case-3.png';
const Projects = () => {
  const projects = [

    {
      title: '市政工程项目',
      type: '概预算审核',
      desc: '市政道路工程概预算结算审核',
      image: case1
    },
    {
      title: '商业综合体项目',
      type: '招投标',
      desc: '商业综合体项目招标代理服务',
      image: case2
    }
  ];

  return (
    <section className="projects-section">
      <div className="container">
        <h2 className="section-title">成功案例</h2>
        <p className="section-subtitle">精选项目，展示实力</p>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card card">
              <div className="project-image">
                <img src={project.image} alt={project.title} />
                <div className="project-overlay">
                  <Link to="/projects" className="btn btn-primary">查看详情</Link>
                </div>
              </div>
              <div className="project-info">
                <span className="project-type">{project.type}</span>
                <h3>{project.title}</h3>
                <p>{project.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="projects-more">
          <Link to="/projects" className="btn btn-secondary">查看更多案例</Link>
        </div>
      </div>
    </section>
  );
};

export default Projects;



